<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
            Ranking del estudiante
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" class="d-flex justify-space-between">
                <div>
                  <p>Tipo de evaluación</p>
                  <v-radio-group v-model="tipoGraph" @change="getRankingStuBySec()" row>
                    <v-radio label="Evaluaciones" value="EVALUACIONES" />
                    <v-radio label="Somos hábiles" value="SOMOS HÁBILES" />
                    <v-radio label="Simulador" value="SIMULADOR" />
                  </v-radio-group>
                </div>

                <v-card outlined>
                  <v-card-text>
                    <v-row dense class="d-flex text-center">
                      <v-col cols="12" class="d-flex justify-center primary--text">
                        <v-icon color="yellow" left>
                          fas fa-star
                        </v-icon>
                        Ranking de la sección
                      </v-col>
                      <v-col cols="12" class="text-h6">
                        {{ posicionAlumno }}
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">

                <!-- <v-select v-model="tipoGraph" :items="listTipoGraph" label="Tipo de evaluación" single-line dense
              hide-details outlined small class="my-select" append-icon="mdi-chevron-down"></v-select> -->
                <ComundataTablecomp :headers="HeadersRankeds" :items="rankingAlumnos">
                  <template v-slot:rank_alumno="{ item }">
                    <div>
                      <v-avatar v-if="item.rank_alumno == 1">
                        <v-img src="../../../../../public/first.png"></v-img>
                      </v-avatar>
                      <v-avatar v-else-if="item.rank_alumno == 2">
                        <v-img src="../../../../../public/second.png"></v-img>
                      </v-avatar>
                      <v-avatar v-else-if="item.rank_alumno == 3">
                        <v-img src="../../../../../public/third.png"></v-img>
                      </v-avatar>
                      <div v-else>
                        {{ item.rank_alumno }}
                      </div>
                    </div>
                  </template>

                  <template v-slot:nombre_completo="{ item }">
                    <v-chip small :color="filter.id_alumno == item.id_alumno ? 'primary' : ''">
                      {{ item.nombre_completo }}
                    </v-chip>
                  </template>
                </ComundataTablecomp>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- SOMOS HÀBILES O SIMULADORES -->
      <v-col cols="12" md="6" v-if="tipoGraph !== 'EVALUACIONES'">
          <LineChart :filter="filter" :change="tipoGraph" ref="lineChart"></LineChart>
      </v-col>

      <!-- EVALUACIONES: RANKING Y LINE CHART -->
      <v-col v-else cols="12" md="6">
        <MetricasEvaluaciones :filter="filter" :change="tipoGraph" ref="metricaPerEval"></MetricasEvaluaciones>
      </v-col>


    </v-row>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { HeadersRankeds } from '../../../../helpers/headersTable';


import MetricasEvaluaciones from './MetricaEvaluaciones.vue'
import LineChart from "./LineChart.vue";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';

export default {
  name: 'ProgresoEstudianteContainer',
  props: ['filter'],
  components: {
    ComundataTablecomp,
    MetricasEvaluaciones,
    LineChart
  },
  data() {
    return {
      intervals: ['Día', 'Semana', 'Mes', 'Periodo', 'Año'],
      currentInterval: 'Año',
      rankingAlumnos: [],
      somosHabilesEst: [],
      posicionAlumno: "",
      filteredData: new Map(),
      HeadersRankeds,

      additionalDataMap: new Map(),
      tipoGraph: "EVALUACIONES",
      dataStorage: sessionStorage,
      evalGraph: false
    }
  },

  methods: {

    async getRankingStuBySec() {
      this.rankingAlumnos = []
      if (this.tipoGraph == 'EVALUACIONES') {
        try {
          const response = await axios.get("/metricaSomosHabiles/rankingPorSeccion", {
            params: {
              id_an_lect: sessionStorage.id_ano_lectivo,
              id_colegio: sessionStorage.id_colegio,
              id_seccion: this.filter.id_seccion,
              soloRealizados: true
            }

          })

          this.rankingAlumnos = response.data.data;

          const alumno = this.rankingAlumnos.find(a => a.id_alumno === this.filter.id_alumno);

          if (!alumno) {
            this.posicionAlumno = "0";
            return;
          }

          const totalAlumnos = this.rankingAlumnos.length;
          const rankingAlumno = parseInt(alumno.rank_alumno);

          this.posicionAlumno = rankingAlumno + '/' + totalAlumnos;

        } catch (error) {
          console.error("Error en ranking", error);
        }
      } else {
        try {
          const response = await axios.get("/rankingPorSeccionMet/rankSomosHabiles", {
            params: {
              tipo_eval: this.tipoGraph,
              id_an_lect: sessionStorage.id_ano_lectivo,
              id_colegio: sessionStorage.id_colegio,
              id_seccion: this.filter.id_seccion,
              soloRealizados: true
            }

          })
          this.rankingAlumnos = response.data.data;

          const alumno = this.rankingAlumnos.find(a => a.id_alumno === this.filter.id_alumno);

          if (!alumno) {
            this.posicionAlumno = "0";
            return;
          }

          const totalAlumnos = this.rankingAlumnos.length;
          const rankingAlumno = parseInt(alumno.rank_alumno);

          this.posicionAlumno = rankingAlumno + '/' + totalAlumnos;

        } catch (error) {
          console.error("Error en ranking", error);
        }
      }

    },

    

    cambiarGrafProgEval(){
      if(this.tipoGraph == "EVALUACIONES") this.evalGraph = true
      else this.evalGraph = false
    },



    updateData(){
      console.log("fas");
      if(this.tipoGraph == 'EVALUACIONES') this.$refs.metricaPerEval.fetchDataFromAPI();
      else this.$refs.lineChart.fetchDataFromAPI();
    },




    limpiarData() {
      this.additionalDataMap.clear();
    }
  },



  mounted() {
    this.getRankingStuBySec();
  },
}
</script>

<style scoped>
.my-select .v-select__slot {
  padding-top: 0;
  padding-bottom: 0;
}

.my-select .v-label {
  font-size: 0.875rem;
}

.my-select .v-icon {
  font-size: 18px;
}

.my-select .v-select__selections {
  font-size: 0.875rem;
}
</style>